<script>
	import {onDestroy} from "svelte";
	import {cartItemsStore, cartTotalStore, addToCart, decrementItemInCart, incrementItemInCart, loadCart} from "./cart/cart-store.js";
	import {
		filterAllergens,
		filterFavorites,
		loadFavorites,
		toggleFavorite,
		favsStore,
		filtersStore,
		optionsStore,
		publishConfigStore, tenantKeyStore, menuStore
	} from "./core/app-store.js";
	import {
		closeAllergensFilterPanel,
		toggleAllergensFilterPanel,
		toggleSectionsPanel,
		toggleDetailsScreen,
		openCartScreen,
		closeCartScreen,
		screensStore
	} from "./core/screens-manager.js";
	import {scrollToElementId, scrollToTop} from "./core/utils.js";
	import Filters from "./components/Filters.svelte";
	import DetailsScreen from "./DetailsScreen.svelte";
	import Sections from "./components/Sections.svelte";
	import SocialLinks from "./components/SocialLinks.svelte";
	import CartWidget from "./cart/CartWidget.svelte";
	import CartScreen from "./cart/CartScreen.svelte";
	import Image from "./components/Image.svelte";
	import {previewListener} from "./core/preview.js";

	loadCart();

	const publishConfig = M.publishConfig;
	let tenantKey;
	let favoritesList = [];
	let screens = {};

	let menu = JSON.parse(JSON.stringify(M.menu));

	const uns1 = favsStore.subscribe(list => {

		favoritesList = list;

		menuStore.update(menu => {
			menu.sections.forEach(section => {
				section.records.forEach(r => {
					r.isFavorite = favoritesList.includes(r.id);
				});
			});

			return {...menu};
		})
	});

	const applyFilter = (filters) => {

		menuStore.update(menu => {

			menu.sections.forEach(s => {
				s.records.forEach(r => {
					const intersectedCount = (r.allergens || []).filter(a => filters.allergens.indexOf(a) > -1).length;
					const allergenFilter = intersectedCount !== 0;
					const favoritesFilter = filters.favorites === true && !favoritesList.includes(r.id);

					r.isFilteredOut = allergenFilter || favoritesFilter;
				});

				s.isFilteredOut = s.records.filter(r => !r.isFilteredOut).length === 0;
			});

			return {...menu};
		});
	}

	const unsM = menuStore.subscribe(x => {
		menu = x;

		if (screens.detailsRecord !== null && screens.detailsRecord !== undefined) {
			menu.sections.forEach(s => {
				s.records.forEach(r => {
					if (r.id === screens.detailsRecord.id) {
						screensStore.update(s => {
							s.detailsRecord = r;
							return s;
						})
					}
				})
			})
		}
	});
	const unsS = screensStore.subscribe(s => screens = s);
	const unsF = filtersStore.subscribe(filters => applyFilter(filters));
	const unsT = tenantKeyStore.subscribe(key => tenantKey = key);
	const unsP = publishConfigStore.subscribe(config => document.title = config?.restaurantName);

	const unsC = cartItemsStore.subscribe(cartItems => {

		menuStore.update(menu => {

			// TODO: Needs optimization
			menu.sections.forEach(s => {
				s.records.forEach(r => {
					r._orderedItems = 0;
					r.prices.forEach((p, idx) => {
						p._count = undefined;
						cartItems.forEach(cartItem => {
							if (r.id === cartItem.id && idx === cartItem.priceIndex) {
								p._count = cartItem.count;
								r._orderedItems += cartItem.count;
							}
						});
					});
				});
			});

			return {...menu};
		});
	});

	loadFavorites(menu);

	onDestroy(() => {
		uns1();
		unsM();
		unsS();
		unsF();
		unsT();
		unsP();
		unsC();
	});

	const removeFromCartHandler = (record) => {
		if ((record.prices || []).length > 0) {
			const index = 0;
			const price = record.prices[index];
			decrementItemInCart(record, price, index);
		}
	}

	const addToCartHandler = (record, priceIdx) => {

		if ((record.prices || []).length > 0) {

			const index = priceIdx || 0;
			const price = record.prices[index];

			if ((record._orderedItems || 0) === 0) {
				addToCart(record, price, index);
			}
			else {
				incrementItemInCart(record, price, index);
			}
		}
	}

	previewListener();
</script>

<style>
	header {
		background: var(--header-background);
		display: flex;
		flex-direction: column;
		gap: .6rem;
		align-items: center;
		text-align: center;
		padding: 1rem 1rem 1.5rem 1rem;
	}
	header h1 {
		font-size: 2.5em;
		font-weight: 600;
		padding: 0;
		margin: 0;
		line-height: 1;
	}
	main {
		display: flex;
		flex-direction: column;
		flex: 1;
	}
	.rest-desc {
		margin: 0;
		font-size: .8rem;
		opacity: .7;
		letter-spacing: .25px;
	}
	.rest-phones {
		margin: 0;
		font-weight: 400;
	}
	.actions {
		padding: 0 1rem;
		display: flex;
		align-items: center;
		line-height: 1.5;
		gap: .75rem;
		background-color: var(--bg-color);
		font-size: .75rem;
		font-weight: 400;
		font-family: var(--font-2);
	}
	.actions .action {
		display: flex;
		align-items: center;
		gap: 0.25rem;
	}
	.actions .action:first-child {
		flex: 1 1;
		padding: 0.5rem 0;
	}
	.filter--applied {
		position: relative;
	}
	.filter--applied:after {
		position: absolute;
		content: '1';
		top: 0;
		right: -0.6rem;
		width: .6rem;
		height: .6rem;
		background: #d6b7a4;
		border-radius: 50%;
		font-size: 7px;
		text-align: center;
		color: white;
	}

	.sections {
		display: flex;
		flex-direction: column;
		gap: .8rem;
	}

	.section-header {
		display: flex;
		gap: .25rem;
		padding: 16px 16px 0 16px;
		flex-direction: column;
		align-items: flex-start;
	}
	.section-header .section-title {
		color: #000;
		font-family: var(--font-1);
		font-size: 1.4rem;
		font-weight: 400;
		margin: 0;
		padding: 0;
		line-height: 20px; /* 100% */
		width: 100%;
		display: flex;
		align-items: baseline;
	}
	.section-header .section-title span {
		flex: 1 1;
	}
	.section-header .section-subtitle {
		color: #777;
		font-family: var(--font-2);
		font-size: .9rem;
		font-style: normal;
		font-weight: 300;
		line-height: normal;
		color: hsla(0, 0%, 47%, 1);
	}
	.section-header hr {
		margin: 0.5rem 0 1rem 0;
		border-top: none;
		border-left: none;
		border-right: none;
		border-bottom: 1px solid #E0DED9;
		width: 100%;
	}

	.section-records {
		display: flex;
		flex-direction: column;
		gap: 1rem;
		padding: 0 1.25rem;
		margin: 0;
	}

	.record {
		display: flex;
		flex-direction: column;
		gap: 0.125rem;
	}
	.record .attribute ul {
		display: flex;
		gap: .25rem;
	}
	.record .attribute ul li {
		background: #DF9393;
		border-radius: .25rem;
		padding: 0 .24rem;
		font-size: 10px;
		line-height: 14px;
		color: white;
		text-transform: capitalize;
	}
	.record .content {
		display: flex;
		gap: .4rem;
	}
	.record .title-block {
		flex: 1 1;
		display: flex;
		flex-direction: column;
		gap: .25rem;
	}
	.record .title-block .title {
		display: flex;
		align-items: center;
		font-family: var(--font-1);
		text-transform: uppercase;

		color: #000;
		font-size: 14px;
		font-style: normal;
		font-weight: 500;
		line-height: 14px; /* 116.667% */
	}
	.record .title-block .title .fav {
		margin-right: .25rem;
	}
	.record .descr {
		color: #777;
		font-family: var(--font-2);
		font-size: 12px;
		font-style: normal;
		font-weight: 300;
		line-height: 14px; /* 116.667% */
	}
	.record .allergens ul {
		display: flex;
		gap: .25rem;
	}
	.record .allergens ul li {
		background: #F6F0E7;
		color: #777777;
		padding: 0 .25rem;
		border-radius: .25rem;

		font-family: var(--font-2);
		font-size: 10px;
		font-style: normal;
		font-weight: 300;
		line-height: 14px; /* 140% */
		text-transform: capitalize;
	}
	.record .prices {
		display: flex;
		flex-direction: column;
		align-items: end;
		gap: .625rem;
	}
	.record .prices .price-block {
		display: flex;
		align-items: center;
		line-height: 1.4rem;
		gap: .25rem;
		width: 100%;
	}
	.record .prices .price-block .weight {
		color: #C7C7C7;
		text-align: right;
		font-family: var(--font-2);
		font-size: 10px;
		font-style: normal;
		font-weight: 400;
		line-height: 10px; /* 100% */
	}
	.record .prices .price-block .price {
		flex: 1 1;
		color: #000;
		text-align: right;
		font-family: var(--font-2);
		font-size: 14px;
		font-style: normal;
		font-weight: 400;
		line-height: 12px; /* 100% */
	}
	.record .prices .price-block .action {
		line-height: 1;
		position: relative;
	}
	.counter-badge {
		position: absolute;
		top: -6px;
		right: -6px;
		background: #47C034;
		border-radius: 50%;
		width: 1.2em;
		height: 1.2em;
		line-height: 1.2em;
		color: white;
		text-align: center;
		font-family: var(--font-2);
		font-size: .5rem;
	}

	footer {
		padding: 1rem;
		text-align: center;
		background: var(--footer-bg-color);
		margin-top: 3rem;
	}
	footer h2 {
		padding-top: .5rem;
		text-transform: uppercase;
		font-weight: 500;
		font-size: 1em;
	}
	footer p {
		font-size: .9rem;
	}

	.cart-space {
		height: 3.5rem;
	}
</style>


<CartWidget total={$cartTotalStore}
			showTotal={$publishConfigStore.userCanSeeTotal}
			publishConfig={$publishConfigStore}
			on:openCartScreen={openCartScreen}>
</CartWidget>


<DetailsScreen record={$screensStore.detailsRecord}
			   on:toggleFavorite={toggleFavorite}
			   on:close={toggleDetailsScreen}>
</DetailsScreen>


<CartScreen opened={$screensStore.cartOpened}
			showTotal={$publishConfigStore.userCanSeeTotal}
			on:close={closeCartScreen}>
</CartScreen>


<!-- MAIN CONTENT -->
<header class="layer-sections">

	<img src="./images/logo.png" alt="" style="max-height: 80px; mix-blend-mode: multiply">
	<h1>{$publishConfigStore.restaurantName}</h1>

	{#if ($publishConfigStore.restaurantDescription)}
		<p class="rest-desc">{$publishConfigStore.restaurantDescription}</p>
	{/if}

	{#if ($publishConfigStore.restaurantPhones)}
		<p class="rest-phones">
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Phone"><path d="M10.554 6.24L7.171 2.335c-.39-.45-1.105-.448-1.558.006L2.831 5.128c-.828.829-1.065 2.06-.586 3.047a29.207 29.207 0 0 0 13.561 13.58c.986.479 2.216.242 3.044-.587l2.808-2.813c.455-.455.456-1.174.002-1.564l-3.92-3.365c-.41-.352-1.047-.306-1.458.106l-1.364 1.366a.462.462 0 0 1-.553.088 14.557 14.557 0 0 1-5.36-5.367.463.463 0 0 1 .088-.554l1.36-1.361c.412-.414.457-1.054.101-1.465z"/></svg>
			<span>{$publishConfigStore.restaurantPhones}</span>
		</p>
	{/if}

</header>

<main>
	<div class="actions flex-between ai-center">
		<span class="action" on:click={toggleSectionsPanel}>
			<span>Разделы меню</span>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ChevronDown"><path d="M4 9l8 8 8-8"/></svg>
		</span>

		{#if (favoritesList.length > 0)}
		<span class="action {$filtersStore.favorites ? 'filter--applied' : ''}" on:click={filterFavorites}>
			Любимые блюда
		</span>
		{/if}

		{#if ($publishConfigStore.showAllergens)}
		<span class="action {$filtersStore.allergens.length > 0 ? 'filter--applied' : ''}" on:click={toggleAllergensFilterPanel}>
			<span>Фильтр</span>
			<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ChevronDown"><path d="M4 9l8 8 8-8"/></svg>
		</span>
		{/if}
	</div>

	<!-- MENU SECTIONS FILTER -->
	<Sections opened={$screensStore.sectionsOpened}
			  sections={menu.sections}
			  on:scrollToSection={(e) => scrollToElementId(e?.detail?.id)}>
	</Sections>

	<!-- ALLERGENS FILTERS -->
	<Filters opened={$screensStore.filtersOpened}
			 on:filter={filterAllergens}
			 on:close={closeAllergensFilterPanel}>
	</Filters>

	<!-- MENU SECTIONS & ITEMS -->
	<div class="sections">
		{#each menu.sections as section, idx}
			{#if (section.isFilteredOut !== true)}
				<div class="section">

					<!-- SECTION HEADER -->
					<div class="section-header">
						{#if (section.title) }
							<h3 id={section.id} class="section-title">
								<span>{section.title}</span>
								{#if (idx > 0) }
									<small on:click={() => scrollToTop()}>
										<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-ArrowUp"><path d="M12 20V4"/><path d="M5 11l7-7 7 7"/></svg>
									</small>
								{/if}
							</h3>
						{/if}

						{#if (section.subTitle) }
							<div class="section-subtitle">{ section.subTitle }</div>
						{/if}

						<hr>
					</div>

					<section class="section-records">
						{#each section.records as record }
							{#if (record.isFilteredOut !== true)}

								<div class="record">

									{#if (record.attr && record.attr.length > 0)}
									<div class="attribute">
										<ul>
											{#each record.attr as attr }
											<li>{ attr }</li>
											{/each}
										</ul>
									</div>
									{/if}

									<div class="content">

										<div class="title-block">
											<div class="title">

												{#if record.isFavorite}
												<div class="fav">
													<svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Heart"><path d="M7 3C4.239 3 2 5.216 2 7.95c0 2.207.875 7.445 9.488 12.74a.985.985 0 0 0 1.024 0C21.125 15.395 22 10.157 22 7.95 22 5.216 19.761 3 17 3s-5 3-5 3-2.239-3-5-3z"/></svg>
												</div>
												{/if}

												{record.name || ''}
											</div>
											<div class="descr">
												{record.description || ''}
											</div>

											{#if (record.allergens && record.allergens.length > 0)}
											<div class="allergens">
												<ul>
													{#each record.allergens as allergens}
													<li>{ allergens }</li>
													{/each}
												</ul>
											</div>
											{/if}
										</div>

										<div class="prices">
											{#each record.prices as price, priceIdx }
												<div class="price-block">
													<span class="weight">{ price.weight || '' }</span>
													<span class="price">{ price.price }{ publishConfig?.currency || ''}</span>

													<!-- ADD -->
													{#if ((price._count || 0) === 0)}
													<span class="action" on:click={addToCartHandler(record, priceIdx)}>
														<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-CirclePlus"><path d="M12 8v4m0 0v4m0-4h4m-4 0H8"/><circle cx="12" cy="12" r="10"/></svg>
													</span>
													{/if}

													{#if ((price._count || 0) !== 0)}
													<span class="action">
														<span class="counter-badge">{price._count}</span>
														<svg width="1em" height="1em" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M13 8.00002C13 4.91669 10.662 2.37269 7.66668 2.03935V0.666687H6.33334V2.03935C3.33801 2.37269 1.00001 4.91669 1.00001 8.00002V9.33335H13V8.00002ZM2.33334 8.00002C2.33334 5.42735 4.42734 3.33335 7.00001 3.33335C9.57268 3.33335 11.6667 5.42735 11.6667 8.00002H2.33334ZM0.333344 10H13.6667V11.3334H0.333344V10Z" fill="#47C034"/>
														</svg>
													</span>
													{/if}

												</div>
											{/each}
										</div>
									</div>


									<!--
									<div style="display: none;" class="buttons">
										{#if ( (record?._orderedItems || 0) > 0)}
											<button class="add-button" on:click|stopPropagation={removeFromCartHandler(record)}>-</button>
											<span>{record?._orderedItems}</span>
										{/if}
										<button class="add-button" on:click|stopPropagation={addToCartHandler(record)}>+</button>
									</div>
									-->


								</div>

							{/if}
						{/each}
					</section>

				</div>
			{/if}
		{/each}
	</div>


</main>

<footer class="layer-sections">

	<h2>{$publishConfigStore.restaurantName}</h2>

	<SocialLinks socialLinks={$publishConfigStore.socialLinks}></SocialLinks>

	{#if $publishConfigStore.restaurantAddress}
	<p>
		{$publishConfigStore.restaurantAddress}
		(<a href="https://maps.google.com/?q={$publishConfigStore.restaurantAddress}" target="_blank" rel="nofollow noopener">карта</a>)
	</p>
	{/if}

	<div class="dm-label">
		Меню сделано с <a href="https://digital-menu.ru/?utm_source=menu&utm_medium=footer&utm_campaign={tenantKey}">digital-menu.ru</a>
	</div>

	{#if ($cartTotalStore?.count > 0)}
		<div class="cart-space"></div>
	{/if}
</footer>
